<template>
  <div>
    <placement-activity-chart :title="dashboardTitle" />
  </div>
</template>

<script>
import PlacementActivityChart from './features/PlacementActivityChart';
import { AssignmentsListingActions } from '@/app/features/assignments/features/assignments-listing/assignments-listing.keys';

import { AppActions } from '@/app/app.keys';

export default {
  name: 'Dashboard',
  components: {
    PlacementActivityChart
  },
  computed: {
    user() {
      return this.$store.state.currentUser;
    },
    userRoles() {
      return this.$store.state.currentUser.roles.map(r => r.role_name);
    },
    dashboardTitle() {
      let title;
      let roles = this.userRoles;
      if (roles.includes('Branch Admin') || roles.includes('Branch Manager')) {
        title = this.user.branchName;
      } else if (roles.includes('Recruiter') || roles.includes('Account Manager')) {
        title = `${this.user.firstName} ${this.user.lastName}`;
      } else if (
        roles.includes('System Admin') ||
        roles.includes('Senior Accounting') ||
        roles.includes('Executive')
      ) {
        title = 'All Branches';
      }
      return title;
    }
  },
  watch: {
    user: {
      immediate: true,
      handler(currentVal, oldVal) {
        if (currentVal && oldVal && currentVal.id !== oldVal.id) {
          this.$store.dispatch(AssignmentsListingActions.RetrieveDashboardSummary, this.userRoles);
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('dashboard.title'));
    this.$store.dispatch(AssignmentsListingActions.RetrieveDashboardSummary, this.userRoles);
  }
};
</script>
<style scoped></style>
